import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styled from "styled-components";
import configs from "../configs";
import { loadBrandingConfig } from "./color-config/loadBranding.js";

const brandingFile = loadBrandingConfig(configs.REACT_APP_NAME);
const logo = brandingFile.head.favicon;

const StyledError = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  color: ${props => props.theme.red};
  gap: 16px;
  text-align: center;
  padding: 0 16px;

  svg {
    margin-bottom: 16px;
  }
`;

export default class Error extends Component {
  static propTypes = {
    message: PropTypes.node
  };

  render() {
    return (
      <StyledError>
        <Link to="/">
          <img src={logo} alt="Logo" />
        </Link>
        {this.props.message}
      </StyledError>
    );
  }
}
